import { render, staticRenderFns } from "./Set_basis.vue?vue&type=template&id=35deea1a&scoped=true"
import script from "./Set_basis.vue?vue&type=script&lang=js"
export * from "./Set_basis.vue?vue&type=script&lang=js"
import style0 from "./Set_basis.vue?vue&type=style&index=0&id=35deea1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35deea1a",
  null
  
)

export default component.exports